module.exports = __webpack_public_path__ + "RobotoMedium.e6f6ddd07161e28488ef.woff2";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoMedium.woff2
// module id = ../../../../../src/fonts/RobotoMedium.woff2
// module chunks = 3